// Edit this list to change the form. `name` must match the Sheet column header
// in scripts/signup-endpoint.gs — change one, change the other.
const fields = [
  { name: 'fullName', label: 'Full name', type: 'text', required: true },
  {
    name: 'phone',
    label: 'Phone number',
    type: 'tel',
    required: true,
    hint: 'We will WhatsApp or call you on this number.',
  },
  {
    name: 'email',
    label: 'Email address',
    type: 'email',
    required: true,
    hint: 'So we always have a way to reach you.',
  },
  {
    name: 'classes',
    label: 'Which classes are you interested in?',
    type: 'checkboxes',
    required: true,
    hint: 'Select all that apply.',
    options: [
      'CSEC Math Form 4',
      'CSEC Math Form 5',
      'CSEC Add Math Form 4',
      'CSEC Add Math Form 5',
      'CAPE Pure Unit 1',
      'CAPE Pure Unit 2',
    ],
  },
  {
    name: 'notes',
    label: 'Anything else you would like us to know?',
    type: 'textarea',
    hint: 'Optional — questions, concerns, anything at all.',
  },
];

export default fields;
